import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IObraUsersRequest } from 'Data/interfaces/Obra/IObraUsers';
import { ISharedUser } from 'Data/interfaces/User/ISharedUser';

export const useQueryUpdateUsersObra = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IObraUsersRequest) => {
      return ObrasApiV2.updateUsers(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        }),
      ]);

      const newSharedUser: ISharedUser = {
        ...data.data,
        UserFk: data.data.UserFk || variables.userId,
        UserId: data.data.UserId || variables.userId,
        isShared: true,
      };

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (oldData) => {
        return oldData?.map((obra) => {
          if (obra.ConstructionSiteId === variables.constructionStieId) {
            const sharedIndex = obra?.SharedUsers?.findIndex((user: ISharedUser) => {
              return user.UserFk === variables.userId || user.UserId === variables.userId;
            });

            if (sharedIndex === -1) {
              return { ...obra, SharedUsers: [...obra.SharedUsers, newSharedUser] };
            }
          }
          return obra;
        });
      });
      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        (oldData) => {
          if (oldData && oldData.ConstructionSiteId === variables.constructionStieId) {
            const sharedIndex = oldData?.SharedUsers?.findIndex((user: ISharedUser) => {
              return user.UserFk === variables.userId || user.UserId === variables.userId;
            });

            if (sharedIndex === -1) {
              return { ...oldData, SharedUsers: [...oldData.SharedUsers, newSharedUser] };
            }
          }
          return oldData;
        },
      );

      toastHandler.showSuccess('Obra compartilhada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao compartilhar Obra!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    updateUsersObra: mutate,
    isLoading: isPending,
  };
};
